import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';
import { FeedbackTrigger } from './FeedbackTrigger';

/**
 * Der Auslöser steht global in der Kopfzeile und rendert sofort — lazy würde
 * hier nur ein Aufpoppen erzeugen (analog NotificationsBell).
 */
const manifest: SkillManifest = {
  key: 'feedback',
  name: 'Rückmeldungen',
  description:
    'Fehler und Wünsche direkt aus der Anwendung melden, geschrieben oder diktiert. ' +
    'Daraus entsteht ein GitHub-Issue, sofern eine Anbindung eingerichtet ist.',
  category: 'core',
  version: '0.1.0',
  enabledByDefault: true,
};

export const feedbackSkill: FrontendSkill = {
  manifest,
  slots: {
    'global.topbar.actions': [
      {
        key: 'feedback-trigger',
        // Vor der Glocke (20): Melden ist eine Aktion, Benachrichtigungen sind
        // eine Anzeige.
        order: 10,
        render: FeedbackTrigger,
      },
    ],
  },
};
